import { gql } from '@apollo/client/core'

export interface PageInfo {
  endCursor?: string
  hasNextPage: boolean
}

export interface Node<T> {
  node: T
}

export interface PaginatedList<T> {
  pageInfo: PageInfo
  edges: Node<T>[]
}

export function extractPaginatedData<T>(paginatedList?: PaginatedList<T>): T[] {
  if (!paginatedList) return []
  return paginatedList.edges.map(e => e.node)
}

export const pageInfoFragment = gql`
  fragment PageInfoProps on PageInfo {
    endCursor
    hasNextPage
  }
`
